import * as React from "react";
import { Container } from "@mui/material";
import ReportTabs from "../components/ReportTabs";
import Loading from "../components/Loading";

export default function Reports(props) {
    const { user, token, handleOpenSnackbar, employees, darkState } = props;
    const [isLoading, setIsLoading] = React.useState(false);

    return (
        <div style={{ paddingTop: "1rem" }}>
            <Container
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    height: "100%",
                }}
            >
                <ReportTabs
                    user={user}
                    token={token}
                    handleOpenSnackbar={handleOpenSnackbar}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    employees={employees}
                    darkState={darkState}
                />
            </Container>
            <Loading open={isLoading} />
        </div>
    );
}
